<block-ui></block-ui>


  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="LookupForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="LookupForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->
          <div ngbDropdown class="d-inline-block" [ngStyle]="{'display': ShowPageContent==true?'block':'none'}">
            <button ngbDropdownToggle href="javascript:;" type="button" class="btn btn-sm btn-light-primary me-3" id="FiltersDropdown" title="Filter">
              <i class="fas fa-filter me-1"></i>
              {{utilityService.getResourceValue("Filter")}}
            </button>
            <div *ngIf="IsFilterLoaded" ngbDropdownMenu aria-labelledby="FiltersDropdown" class=" filter-container menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary  w-250px w-md-500px fw-bold py-3 ">
              <form [formGroup]="LookupForm">
                <div class="px-7 py-5">
                  <div class="row">
                    <div class="col-lg-12">
                      <div *ngIf="LookupGroupsList.length>0" class="mb-10">
                        <BBSF-DropdownList [options]="LookupGroupsOptions" [group]="LookupForm"></BBSF-DropdownList>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-light btn-active-light-primary pv-reset btn-sm" d="applyFiltersBtn"
                            (click)="resetFilters()">
                      {{utilityService.getResourceValue("Reset")}}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <button href="javascript:;" class="btn btn-sm btn-light-primary me-3" (click)="showGenerateApplicationEnumsModal(GenerateCodeModal)">
            <i class="fa fa-key me-1"></i>{{utilityService.getResourceValue("GenerateApplicationEnums")}}
          </button>

          <button href="javascript:;" class="btn btn-sm btn-light-primary me-3" (click)="showGenerateCodeAllModal(GenerateCodeModal)">
            <i class="fa fa-key me-1"></i>{{utilityService.getResourceValue("GenerateCode")}}
          </button>

          <button href="javascript:;" class="btn btn-sm btn-light-primary me-3" (click)="showGeneratSysNameModal(GenerateCodeModal)">
            <i class="fa fa-key me-1"></i>{{utilityService.getResourceValue("GenerateSysName")}}
          </button>
          <button type="button" class="btn btn-sm btn-primary" title="Add" (click)="showAddLookupModal(AddLookupModal)">
            <i class="fas fa-plus me-1"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>

          <!-- end::Menu -->
        </div>
      </div>
      <div class="card-body py-3">
        <div class="table-responsive">
          <!--begin::Permission list-->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Description")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("LookupGroups")}}</th>
                <th class="min-w-150px" *ngIf="!ProductionMode">{{utilityService.getResourceValue("SysName")}}</th>
                <th class="min-w-50px">{{utilityService.getResourceValue("Manageable")}}</th>

                <th class="min-w-150px">{{utilityService.getResourceValue("Action")}}</th>


              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

              <tr *ngFor="let Lookup of LookupPagingResult">

                <td>
                  <a *ngIf="language=='en'" href="javascript:void(0)" [routerLink]="['/Admin/Lookups/LookupItems', Lookup.id,Lookup.name.english,Lookup.name.arabic]" routerLinkActive="router-link-active"
                     class="text-dark">{{Lookup.name.english}}</a>
                  <a *ngIf="language=='ar'" href="javascript:void(0)" [routerLink]="['/Admin/Lookups/LookupItems',Lookup.id,Lookup.name.english,Lookup.name.arabic]" routerLinkActive="router-link-active"
                     class="text-dark">{{Lookup.name.arabic}}</a>
                </td>
                <td *ngIf="language=='en'">{{Lookup.description.english}}</td>
                <td *ngIf="language=='ar'">{{Lookup.description.arabic}}</td>
                <td *ngIf="language=='en'">{{Lookup.lookupGroupName!=null?Lookup.lookupGroupName.english:"Others"}}</td>
                <td *ngIf="language=='ar'">{{Lookup.lookupGroupName!=null?Lookup.lookupGroupName.arabic:"أخر"}}</td>

                <td *ngIf="!ProductionMode" class="align-middle">{{Lookup.sysName}}</td>
                <td>
                  <span *ngIf="Lookup.manageable;else default_no">
                    {{utilityService.getResourceValue("Yes")}}
                  </span>
                  <ng-template #default_no>
                    <span>
                      {{utilityService.getResourceValue("No")}}
                    </span>
                  </ng-template>

                </td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <a class="drop-item px-3" ngbDropdownItem
                         (click)="showEditLookupModal(Lookup,EditLookupModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                      </a>
                      <a class="drop-item px-3" ngbDropdownItem
                         (click)="showGenerateCodeByIdModal(Lookup,GenerateCodeModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("GenerateCode")}}</span>
                      </a>
                      <a *ngIf="(!ProductionMode) ||(Lookup.manageable==true)" ngbDropdownItem class="drop-item px-3"
                         (click)="showDeleteLookupModal(Lookup,deleteLookupModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                      </a>
                    </mat-menu>
                  </div>

                </td>
              </tr>
              <tr *ngIf="LookupPagingResult.length == 0">
                <td [attr.colspan]="ProductionMode ? '5' : '6'">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>

          <!--end::Permission list-->
        </div>

      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setLookupListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="LookupPaging" [group]="LookupForm" #LookupPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>

  </div>


  <!-- Add Modal -->
  <ng-template #AddLookupModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("Lookup")}}</h1>
      </div>
      <form [formGroup]="AddLookupForm" (ngSubmit)="addLookup()">
        <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="AddLookupForm"></BBSF-MultiLingualTextBox>
        <BBSF-MultiLingualTextArea [options]="MultiLingualDescription" [group]="AddLookupForm"></BBSF-MultiLingualTextArea>
        <div *ngIf="!ProductionMode">
          <BBSF-TextBox [options]="SysName" [group]="AddLookupForm"></BBSF-TextBox>
        </div>

        <BBSF-DropdownList [options]="LookupGroups" [group]="AddLookupForm"></BBSF-DropdownList>
        <div *ngIf="!ProductionMode">
          <BBSF-CheckBox [options]="IsManageable" [group]="AddLookupForm"></BBSF-CheckBox>
        </div>
        <div class="text-center pt-7">
          <button type="button" #CloseLookupModal id="CloseLookupModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>


  <!-- Edit Modal -->
  <ng-template #EditLookupModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("Lookup")}}</h1>
      </div>
      <form [formGroup]="EditLookupForm" (ngSubmit)="editLookup()">
        <BBSF-MultiLingualTextBox [options]="EditMultiLingualName" [group]="EditLookupForm"></BBSF-MultiLingualTextBox>
        <BBSF-MultiLingualTextArea [options]="EditMultiLingualDescription" [group]="EditLookupForm"></BBSF-MultiLingualTextArea>
        <BBSF-TextBox *ngIf="!ProductionMode" [options]="EditSysName" [group]="EditLookupForm">
        </BBSF-TextBox>
        <BBSF-DropdownList [options]="EditLookupGroups" [group]="EditLookupForm">
        </BBSF-DropdownList>
        <BBSF-CheckBox *ngIf="!ProductionMode" [options]="EditIsManageable" [group]="EditLookupForm">
        </BBSF-CheckBox>
        <div class="text-center pt-7">
          <button type="button" #CloseEditLookupModal id="CloseEditLookupModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>

  <!-- Delete  Modal -->
  <ng-template #deleteLookupModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("Lookup")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteLookupModal id="CloseDeleteLookupModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="DeleteLookup()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>



  <!-- GenerateCode Modal -->
  <ng-template #GenerateCodeModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("GenerateCode")}}</h1>
      </div>
      <form [formGroup]="GenerateCodeForm">
        <div>
          <BBSF-TextArea [options]="GenerateCodeTextArea" [group]="GenerateCodeForm" #GenerateCodeInput>
          </BBSF-TextArea>

        </div>
        <div class="text-center pt-7">
          <button type="button" #CloseGenerateCodeModal id="CloseGenerateCodeModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="copyInputMessage()">
            {{utilityService.getResourceValue("CopyToClipboard")}}
          </button>
        </div>
      </form>



    </div>
  </ng-template>

